exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".el-avatar[data-v-7619ab15]{flex-shrink:0;border:1px solid #2c5dff}.el-avatar.is-default[data-v-7619ab15]{border:none}", ""]);

